<template>
    <div>
        <!-- 面包屑：名称与菜单配置同步 -->
    <AppBreadcrumb :items="[{ path: 'basicData' }, { label: '用户档案', to: '/userProfile' }, { label: '绑定水表' }]" />
    <!-- 主体区域 -->
    <div class="num">
    <div class="numa">
        <div class="numj">用户档案<div class="vi" /></div>
        <div class="numx" />
        <div class="numf">
            <el-form :v-model="userfima" label-width="80px" class="demo-form-inline">
                <el-form-item label="姓名:">
                    <el-input v-model="userfima.name" disabled size="small"></el-input>
                </el-form-item>&emsp;&emsp;
                <el-form-item label="联系电话:">
                    <el-input v-model="userfima.phone" disabled size="small"></el-input>
                </el-form-item>
                <el-form-item label="活动区域:">
                    <el-select disabled v-model="userfima.location" placeholder="请选择活动区域" size="small">
                    </el-select>
                </el-form-item>
                <el-form-item label="位置信息:">
                    <el-input v-model="userfima.address" disabled size="small" style="width: 550px"></el-input>
                </el-form-item>
                <el-form-item label="表具编号:">
                    <el-input v-model="userfima.meter_id" disabled size="small" style="width: 550px"></el-input>
                </el-form-item>
                <!-- <div class="numbtn">
                    <el-button><i class="el-icon-circle-check" />确认绑定</el-button>
                </div> -->
            </el-form>
        </div>
    </div>
    <!-- 绑定水表 -->
    <div class="numb">
        <div class="numj">绑定水表<div class="vi" />
        <div class="ilo" @click="userAss">
                <span>返回</span>
                <img src="@/views/basicData/userProfile/TableRecord/img/fanhui.png" alt="">
            </div>
        </div>
        <div class="numx" />
        <div class="numbfai">
          <el-input size="small" placeholder="请搜索" v-model="tabfams.search_content"></el-input>
          <el-button size="small" @click="sosuobtn">搜索</el-button>
        </div>
        <div>
        <el-card>
    <el-table :data="tableData" size=mini highlight-current-row v-loading="loading" :header-cell-style = "{background:'#987AFF'}" @current-change="handleCurrentChange" height='570' element-loading-text="拼命加载中">
    <el-table-column type="index" width="100" />
    <el-table-column property="meter_id" label="表具编号" width="170" />
    <el-table-column property="water_type_name" label="用水类型" width="140" :show-overflow-tooltip="true" />
    <el-table-column property="is_use" label="使用状态" width="140" :show-overflow-tooltip="true">
      <template slot-scope="{row: {is_use}}">
        <span v-if="+is_use === 0">未启用</span>
        <span v-else>启用</span>
      </template>
    </el-table-column>
    <el-table-column property="name" label="操作" width="150" >
        <template slot-scope="scope">
        <el-button size="mini" @click="userband(scope.row)">绑定</el-button>
      </template>
    </el-table-column>
  </el-table>
      </el-card>
    </div>
    <div class="numbtn">
        <el-button style="small" @click="userBici"><i class="el-icon-document" />保存</el-button>
    </div>
    </div>
    </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      // pay_id: this.$route.guery.pay_id,
      userfima: {
        project_id: null,
        token: null,
        name: null,
        phone: null,
        location: null,
        address: null,
        meter_id: null
      },
      // table数据
      tableData: [{
        project_id: null,
        not_bind: null,
        meter_id: null,
        water_type: null,
        is_use: null
      }],
      // tab数据加载转圈
      loading: false,
      // tab
      tabfams: {
        project_id: null,
        token: null,
        not_bind: 1,
        search_content: null
      }
    }
  },
  created () {
    // tab
    this.tabfams.project_id = this.$store.state.print.goodsForeNo.project_id
    this.tabfams.token = this.$store.state.print.goodsForeNo.token
    console.log(this.userfima, ' this.userfima')
    this.userDate()
    console.log(this.$route.query.obj)
    this.userfima = this.$route.query.obj
  },
  methods: {
    // 搜索
    sosuobtn () {
      this.$api.userProfile.userTabs(this.tabfams).then((res) => {
        console.log(res, '搜索')
        this.userDate()
      })
    },
    userAss () {
      this.$router.push('/userProfile')
    },
    // 保存
    userBici () {
      this.userfima.project_id = this.$store.state.print.goodsForeNo.project_id
      this.userfima.token = this.$store.state.print.goodsForeNo.token
      console.log(this.userfima, 'this.userfimassssss')
      this.$api.userProfile.userBdifis(this.userfima).then((res) => {
        if (res.data.status === 'success') {
          console.log(res)
          this.$notify({
            title: '成功',
            message: '绑定成功',
            type: 'success'
          })
          this.$router.push('/userProfile')
        }
      })
    },
    // 绑定
    userband (row) {
      console.log(row.meter_id)
      this.userfima.meter_id = row.meter_id
    },
    // table
    userDate () {
      this.$api.userProfile.userTabs(this.tabfams).then((res) => {
        if (res.status !== 200) {
          return this.$message.error('获取数据失败·')
        }
        console.log(res, 'dw')
        this.tableData = res.data.data
      })
    },
    // tab组件
    handleCurrentChange (val) {
    }
  }
}
</script>

<style lang="less" scoped>
// 面包屑
.Gnv {
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  background-color: #ecf0f1;
  font-size: 19px;
  letter-spacing: 1px;
  //   font-family: myFont;
  .el-breadcrumb {
    display: flex;
    align-items: center;
    margin-left: 75px;
    .yai{
      width: 5px;
      height: 17px;
      background-color: #987AFF;
      margin-right: 18px;
    }
    ::v-deep .el-breadcrumb__item{
      margin-left: 0px;
      .el-breadcrumb__inner.is-link{
        font-weight: 100;
        color: #656d92;
  }
    }
  }
}
// 主题区域
.num{
    display: flex;
}
// 解绑水表
.numa{
    margin: 37px 0px 0px 73px;
    width: 701px;
    height: 500px;
    // border-right: 1px solid;
    .numj{
        // width: 133px;
        // height: 30px;
        font-family: SimHei;
        font-size: 25px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 9px;
        letter-spacing: 5px;
        color: #030000;
        display: flex;
        align-items: center;
        .vi{
        z-index: 9999;
        width: 6px;
        height: 23px;
        background-color: #744dfe;
        margin-left: 15px;
        }
    }
    .numx{
        margin-top: 23px;
        width: 701px;
        height: 2px;
        background-color: #dad2f4;
    }
    .numf{
        margin-top: 34px;
        .el-form{
            display: flex;
            flex-wrap: wrap;
            .el-form-item{
                .el-input{
                    width: 220px;
                }
            }
        }
        .numbtn{
                margin-left: 530px;
                .el-button{
                    border: 1px solid #744dfe;
                    i{
                        margin-right: 10px;
                        font-size: 15px;
                    }
                }
            }
    }
}
// 绑定水表
.numb{
    margin-left: 50px;
    margin-top: 30px;
    width: 702px;
    // height: 500px;
    // border: 1px solid;
    .numj{
        // width: 133px;
        // height: 30px;
        font-family: SimHei;
        font-size: 25px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 9px;
        letter-spacing: 5px;
        color: #030000;
        display: flex;
        align-items: center;
        .vi{
        z-index: 9999;
        width: 6px;
        height: 23px;
        background-color: #744dfe;
        margin-left: 15px;
        }
        .ilo{
          cursor: pointer;
            margin-left: 450px;
            font-size: 19px;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 90px;
            height: 33px;
            border-radius: 4px;
            border: solid 1px #977aff;
      span{
        font-family: XinPingHeiTC-W2;
        font-weight: bold;
        font-stretch: normal;
        letter-spacing: 3px;
        color: #484848;
      }
      img{
        width: 27px;
        height: 23px;
      }
    }
    }
    .numx{
        margin-top: 17px;
        margin-bottom: 8px;
        width: 701px;
        height: 2px;
        background-color: #dad2f4;
    }
    .numbfai{
      display: flex;
      padding: 10px 0px;
      .el-input{
        width: 300px;
        border: 1px solid #744dfe;
        border-radius: 6px;
      }
      .el-button{
        margin-left: 20px;
      }
    }
    .el-card{
          border-radius: 10px;
          ::v-deep .el-card__body{
            padding: 0px;
          }
          ::v-deep .el-table__header-wrapper{
            background-color: #987AFF;
              width: 100%;
          }
          ::v-deep .el-table tr{
            background-color: #F9F9F9;
          }
          ::v-deep .el-table thead{
            color: #fff;
            font-weight: 300;
          }
         ::v-deep .cell{
           font-family:myFont;
          }
        }
        ::v-deep .cell{
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
          text-align: center;
        }
       ::v-deep .el-table__header{
         width: 0;
          width: 100%;
        }
        .el-button{
          border: 1px solid #744dfe;
        }
    .numbtn{
        float: right;
        margin-top: 27px;
        .el-button{
            i{
                margin-right: 10px;
            }
        }
    }
}
</style>
